var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [
          _c(
            "div",
            { staticClass: "md-layout md-gutter md-alignment-top-center" },
            [
              _c("md-progress-spinner", {
                attrs: {
                  "md-diameter": 50,
                  "md-stroke": 5,
                  "md-mode": "indeterminate"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.bma
      ? _c(
          "div",
          { staticClass: "md-layout md-gutter md-alignment-top-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-15 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
              },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-fab",
                    on: {
                      click: function($event) {
                        return _vm.goBack()
                      }
                    }
                  },
                  [_c("md-icon", [_vm._v("arrow_back")])],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-75 md-medium-size-70 md-small-size-100 md-xsmall-size-100"
              },
              [
                _c(
                  "md-card",
                  { staticStyle: { width: "100%" } },
                  [
                    _c("md-card-header", [
                      _c("div", { staticClass: "md-title" }, [
                        _vm._v(_vm._s(_vm.bma.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("md-card-content", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "md-layout md-gutter md-alignment-top-center"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "md-layout-item md-size-70" },
                            [
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.bma.description)
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "md-layout-item md-size-30" },
                            [
                              _c("h4", [_vm._v("Untergeordnete Aspekte")]),
                              _vm._v(" "),
                              _vm._l(_vm.bma.children, function(child) {
                                return _c(
                                  "div",
                                  { key: child.hash },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "BusinessModelDetail",
                                            params: { hash: child.hash }
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "md-chip",
                                          {
                                            staticClass: "md-primary",
                                            staticStyle: { margin: "2px" },
                                            attrs: { "md-clickable": "" }
                                          },
                                          [_vm._v(_vm._s(child.name))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _vm.bma.children.length == 0
                                ? _c("div", [_c("h5", [_vm._v("Keine")])])
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "md-layout md-gutter md-alignment-top-center"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "md-layout-item md-size-50",
                              staticStyle: { "margin-bottom": "50px" }
                            },
                            [
                              _c("h3", [_vm._v("Technologieempfehlungen")]),
                              _vm._v(" "),
                              _vm.techrecommendations.length == 0
                                ? _c("p", [
                                    _vm._v(
                                      "\n                Keine Technologieempfehlungen vorhanden\n              "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.techrecommendations, function(tech) {
                                return _c(
                                  "div",
                                  { key: tech.hash },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "no-link",
                                        attrs: {
                                          to: {
                                            name: "TechnologyDetail",
                                            params: { hash: tech.hash }
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "md-card",
                                          {
                                            staticClass:
                                              "margin-twenty md-alignment-top-center md-elevation-1",
                                            attrs: { "md-with-hover": "" }
                                          },
                                          [
                                            _c(
                                              "md-card-header",
                                              { staticClass: "md-title" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(tech.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("md-card-content", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.shorten(tech.description)
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "md-layout-item md-size-50",
                              staticStyle: { "margin-bottom": "50px" }
                            },
                            [
                              _c("h3", [_vm._v("Referenzprojekte")]),
                              _vm._v(" "),
                              _vm.projects.length == 0
                                ? _c("p", [
                                    _vm._v(
                                      "\n                Keine Referenzprojekte hinterlegt\n              "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.projects, function(project) {
                                return _c(
                                  "div",
                                  { key: project.hash },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "no-link",
                                        attrs: {
                                          to: {
                                            name: "ReferenceProjectDetail",
                                            params: { hash: project.hash }
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "md-card",
                                          {
                                            staticClass:
                                              "margin-twenty md-alignment-top-center md-elevation-1",
                                            attrs: { "md-with-hover": "" }
                                          },
                                          [
                                            _c(
                                              "md-card-header",
                                              { staticClass: "md-title" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(project.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("md-card-content", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.shorten(
                                                    project.description
                                                  )
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        ]
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "md-layout-item md-size-10 md-medium-size-20 md-small-size-20 md-xsmall-size-40"
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-706e50fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-706e50fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/businessmodelsearch/detail/BusinessModelDetail.vue
// module id = null
// module chunks = 